'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { ClubBadge } from '~/components/Account/Rewards';
import { useTripLoyaltyPricing } from '../hooks/useTripLoyaltyPricing';
import styles from './TripLoyaltyPriceRow.module.css';
type TripLoyaltyPriceRowProps = {
  children: ReactNode;
};
export const TripLoyaltyPriceRow = t0 => {
  const $ = _c(12);
  const {
    children
  } = t0;
  const t = useTranslations("journey");
  const loyalty = useTripLoyaltyPricing();
  if (!loyalty.hasLoyaltyDiscount) {
    return children;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("loyalty_benefits_club_badge");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ClubBadge size="compact">{t1}</ClubBadge>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = <span className={styles.discountedPrice}>{children}</span>;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== loyalty.originalPerPersonFormatted) {
    t4 = <span className={styles.originalPrice}>{loyalty.originalPerPersonFormatted}</span>;
    $[6] = loyalty.originalPerPersonFormatted;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <span className={styles.priceRow} data-test-id="trip-loyalty-price">{t2}{t3}{t4}</span>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};